var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.625V16.375C17.5 17.4297 16.6406 18.25 15.625 18.25H1.875C0.820312 18.25 0 17.4297 0 16.375V2.625C0 1.60938 0.820312 0.75 1.875 0.75H15.625C16.6406 0.75 17.5 1.60938 17.5 2.625ZM15.625 16.1406V2.85938C15.625 2.74219 15.5078 2.625 15.3906 2.625H2.10938C1.95312 2.625 1.875 2.74219 1.875 2.85938V16.1406C1.875 16.2969 1.95312 16.375 2.10938 16.375H15.3906C15.5078 16.375 15.625 16.2969 15.625 16.1406ZM10.3906 13.25C10.3906 14.1875 9.64844 14.8906 8.75 14.8906C7.8125 14.8906 7.10938 14.1875 7.10938 13.25C7.10938 12.3516 7.8125 11.6094 8.75 11.6094C9.64844 11.6094 10.3906 12.3516 10.3906 13.25ZM7.1875 5.00781C7.1875 4.73438 7.38281 4.5 7.65625 4.5H9.80469C10.0781 4.5 10.2734 4.73438 10.2734 5.00781L10 10.3203C10 10.5547 9.76562 10.75 9.53125 10.75H7.92969C7.69531 10.75 7.46094 10.5547 7.46094 10.3203L7.1875 5.00781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.3efe5ddc8862a464b6bc630e0b1b9bb7.svg";
export { ForwardRef as ReactComponent };